// install: npm install @emailjs/browser
// email used: ramit37707716@gmail.com . PW: adibomeo2427

import React, { useState } from "react";
import emailjs from "@emailjs/browser";
import "./MembershipFormDetailsStyles.css";
import ShikhaaLogo from "../../Assets/Cover/Shikhaa_Logo.png";

const MembershipFormDetails = () => {
  const [formData, setFormData] = useState({
    membershipType: "",
    feeOption: "",
    membershipYear: "",
    fullName: "",
    mailingAddress: "",
    phone: "",
    email: "",
    familyMembers: "",
    volunteerInterest: "",
    culturalInterest: "",
    comments: "",
  });

  const [submissionMessage, setSubmissionMessage] = useState({
    text: "",
    type: "",
  });

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const clearForm = () => {
    setFormData({
      membershipType: "",
      feeOption: "",
      membershipYear: "",
      fullName: "",
      mailingAddress: "",
      phone: "",
      email: "",
      familyMembers: "",
      volunteerInterest: "",
      culturalInterest: "",
      comments: "",
    });
  };

  const handleSubmit = (e) => {
    e.preventDefault();

    const templateParams = {
      to_name: "Shikhaa – The Light",
      user_name: formData.fullName || "Not Provided",
      user_email: formData.email || "Not Provided",
      membershipType: formData.membershipType || "Not Provided",
      feeOption: formData.feeOption || "Not Provided",
      membershipYear: formData.membershipYear || "Not Provided",
      fullName: formData.fullName || "Not Provided",
      mailingAddress: formData.mailingAddress || "Not Provided",
      phone: formData.phone || "Not Provided",
      email: formData.email || "Not Provided",
      familyMembers: formData.familyMembers || "N/A",
      volunteerInterest: formData.volunteerInterest || "Not Provided",
      culturalInterest: formData.culturalInterest || "N/A",
      comments: formData.comments || "N/A",
    };

    emailjs
      .send(
        "service_ompmvso",
        "template_r3x9okp",
        templateParams,
        "R604Ew-z-IC_RRDq_",
      )
      .then(
        () => {
          setSubmissionMessage({
            text: "Membership form submitted successfully!",
            type: "success",
          });

          clearForm();

          setTimeout(() => {
            setSubmissionMessage({ text: "", type: "" });
          }, 10000);
        },
        () => {
          setSubmissionMessage({
            text: "Failed to submit form. Please try again.",
            type: "error",
          });

          setTimeout(() => {
            setSubmissionMessage({ text: "", type: "" });
          }, 10000);
        },
      );
  };

  return (
    <div className="membership-container">
      <div className="MembershipFee_logo">
        <img id="Shikhaa-logo" src={ShikhaaLogo} alt="Shikhaa The Light Logo" />
      </div>

      <h1>Shikhaa – The Light Membership Form</h1>

      <p className="membership-intro">
        Join Shikhaa – The Light and help preserve Bangladeshi culture,
        heritage, language, and community values in South Florida. Your
        membership supports cultural education, youth engagement, community
        programs, and events such as the annual Pitha Festival.
      </p>

      <form onSubmit={handleSubmit}>
        <div className="form-box">
          <label>
            Please Select Membership Type: <span className="required">*</span>
          </label>
          <select
            name="membershipType"
            onChange={handleChange}
            value={formData.membershipType}
            required
          >
            <option value="">Select Type</option>
            <option value="Individual Membership">Individual Membership</option>
            <option value="Family Membership">Family Membership</option>
            <option value="Student / Youth Membership">
              Student / Youth Membership
            </option>
            <option value="Volunteer Membership">Volunteer Membership</option>
          </select>
        </div>

        <div className="form-box">
          <label>
            Please Select Fee Option: <span className="required">*</span>
          </label>
          <select
            name="feeOption"
            onChange={handleChange}
            value={formData.feeOption}
            required
          >
            <option value="">Select Fee</option>
            <option value="Individual Membership Fee">
              Individual Membership Fee
            </option>
            <option value="Family Membership Fee">Family Membership Fee</option>
            <option value="Student / Youth Fee">Student / Youth Fee</option>
            <option value="Volunteer / No Fee">Volunteer / No Fee</option>
          </select>
        </div>

        <div className="form-box">
          <label>
            Membership Year: <span className="required">*</span>
          </label>
          <select
            name="membershipYear"
            onChange={handleChange}
            value={formData.membershipYear}
            required
          >
            <option value="">Select Year</option>
            <option value="2025-2026">2025-2026</option>
            <option value="2026-2027">2026-2027</option>
          </select>
        </div>

        <div className="form-box">
          <label>
            Full Name: <span className="required">*</span>
          </label>
          <input
            type="text"
            name="fullName"
            onChange={handleChange}
            value={formData.fullName}
            required
          />
        </div>

        <div className="form-box">
          <label>
            Mailing Address: <span className="required">*</span>
          </label>
          <input
            type="text"
            name="mailingAddress"
            onChange={handleChange}
            value={formData.mailingAddress}
            required
          />
        </div>

        <div className="form-box">
          <label>
            Phone Number: <span className="required">*</span>
          </label>
          <input
            type="text"
            name="phone"
            onChange={handleChange}
            value={formData.phone}
            required
          />
        </div>

        <div className="form-box">
          <label>
            Email Address: <span className="required">*</span>
          </label>
          <input
            type="email"
            name="email"
            onChange={handleChange}
            value={formData.email}
            required
          />
        </div>

        <div className="form-box">
          <label>Family Members / Children Names (Optional):</label>
          <textarea
            name="familyMembers"
            onChange={handleChange}
            value={formData.familyMembers}
            rows="4"
            placeholder="List family members or children who may participate in Shikhaa programs"
          />
        </div>

        <div className="form-box">
          <label>
            Are you interested in volunteering?{" "}
            <span className="required">*</span>
          </label>
          <select
            name="volunteerInterest"
            onChange={handleChange}
            value={formData.volunteerInterest}
            required
          >
            <option value="">Select Option</option>
            <option value="Yes">Yes</option>
            <option value="No">No</option>
            <option value="Maybe">Maybe</option>
          </select>
        </div>

        <div className="form-box">
          <label>Cultural Interest / Area of Participation (Optional):</label>
          <textarea
            name="culturalInterest"
            onChange={handleChange}
            value={formData.culturalInterest}
            rows="4"
            placeholder="Example: music, recitation, dance, Pitha Festival, youth program, event support"
          />
        </div>

        <div className="form-box">
          <label>Additional Comments (Optional):</label>
          <textarea
            name="comments"
            onChange={handleChange}
            value={formData.comments}
            rows="4"
          />
        </div>

        <div>
          <button type="submit">Submit Membership Form</button>

          {submissionMessage.text && (
            <p
              className={
                submissionMessage.type === "success"
                  ? "success-message"
                  : "error-message"
              }
            >
              {submissionMessage.text}
            </p>
          )}
        </div>
      </form>

      <h2>PAY MEMBERSHIP FEE</h2>
      <p>
        Membership fee payment options will be provided by Shikhaa – The Light.
        You may contact the organization for PayPal, Zelle, or other payment
        instructions.
      </p>

      <div className="payment-options">
        <p>
          Payment can be made by Zelle to:
          <br />
          <strong>shikhaonirban2026@gmail.com</strong>
        </p>
      </div>

      <div className="pdf-download">
        <a
          href="/SHIKHAA_Membership_Application.pdf"
          target="_blank"
          rel="noopener noreferrer"
          className="pdf-button"
          download
        >
          Download Shikhaa Membership Form (PDF)
        </a>
      </div>
    </div>
  );
};

export default MembershipFormDetails;
